import React, { useState } from "react";
import { generateAllInvoices  } from "../../services/invoiceService";

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const BulkInvoiceGenerator = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGenerateAllInvoices = async () => {
    setLoading(true);
    try {
      const response = await generateAllInvoices(selectedMonth);

      if (response.success) {
        setInvoiceUrl(response.url);
        setError("");
      } else {
        setError("Failed to generate invoices. Please try again.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadInvoice = async () => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();
      const file = new Blob([blob], { type: "application/pdf" });

      // Create a temporary download link
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.download = `Invoice-All-${months[selectedMonth - 1]}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      return fileURL; // Return the file URL for sharing
    } catch (error) {
      console.error("Error downloading invoice:", error);
      alert("Failed to download invoice. Try again.");
      return null;
    }
  };


  return (
    <div className="max-w-xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-center mb-4 text-gray-400">📄 Bulk Invoice Generator</h2>

      {error && (
        <div className="bg-red-100 text-red-700 p-3 rounded mb-4 flex items-center gap-2">
          <span>⚠️</span>
          <span>{error}</span>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-lg p-5 mb-6 space-y-4">
        <label className="block text-sm font-semibold text-gray-700">Select Month</label>
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
        >
          <option value="">-- Select Month --</option>
          {months.map((month, index) => (
            <option key={index} value={index + 1}>{month}</option>
          ))}
        </select>

        <button
          onClick={handleGenerateAllInvoices}
          disabled={loading || !selectedMonth}
          className={`w-full py-3 text-white rounded-lg font-semibold text-lg transition ${
            loading || !selectedMonth
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? (
            <div className="flex flex-col items-center justify-center">
              <div className="flex items-center gap-2">
                <svg
                  className="w-5 h-5 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
                <span>Generating Invoices...</span>
              </div>
              <span className="text-sm mt-1 text-white opacity-80 italic">Please wait...</span>
            </div>
          ) : (
            "🚀 Generate All Invoices"
          )}
        </button>
      </div>

      {invoiceUrl && (
        <div className="bg-green-100 p-5 rounded-xl shadow-lg text-center">
          <h3 className="text-xl font-bold text-green-800 mb-2">✅ Invoices Ready!</h3>
          <p className="mb-3 text-green-700">
            Click below to download for <strong>{months[selectedMonth - 1]}</strong>.
          </p>
          <button
            onClick={handleDownloadInvoice}
            className="bg-green-600 text-white px-6 py-2 rounded-lg text-lg font-semibold hover:bg-green-700 transition w-full"
          >
            📥 Download All Invoices PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default BulkInvoiceGenerator;